import { gql } from 'graphql-request';

const FILL_LATER_ITEM_FIELDS = `
  fillLaterItemId
  referenceOrderId
  referenceItemId
  rxNumber
  patientId
  patientName
  drugName
  strength
  ndc
  packSizeValue
  packSizeUnit
  formAlias
  isOtc
  splitQuantity
  scheduledFor
  status
  fillLaterType
  addressDirectoryId
  address {
    line1
    line2
    city
    state
    zip
  }
  referenceAddress {
    line1
    line2
    city
    state
    zip
  }
  failureReason
  splitOrderId
  isOrderPrecreated
  partnerId
  partnerName
  practiceId
  practiceName
  fulfillingPharmacyId
  createdAt
  createdBy
  modifiedAt
  mergeable
  mergeBlockedReason
`;

export const listFillLaterItemsGql = gql`
  query listFillLaterItems(
    $limit: Int
    $offset: Int
    $filter: FillLaterItemsFilter
    $sortBy: FillLaterItemsSortBy
  ) {
    listFillLaterItems(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      items {
        ${FILL_LATER_ITEM_FIELDS}
      }
      totalCount
      limit
      offset
    }
  }
`;

// The dialog only needs to know the write landed; the page is refetched for display. Keep the
// selection to the non-PHI fields so the response carries nothing the caller does not read.
export const rescheduleFillLaterItemGql = gql`
  mutation rescheduleFillLaterItem($input: RescheduleFillLaterItemInput!) {
    rescheduleFillLaterItem(input: $input) {
      fillLaterItemId
      status
      scheduledFor
    }
  }
`;

// POM-6150 owns the mutation; it lives on the rxOrder schema, not fillLater. ignoreSchedule is
// fixed server-side, so the only argument is the id. The result is an outcome, not the row: the
// caller refetches the page to see the new status.
// POM-6182 - merge the queued quantity back onto the parent line item. The row is refetched with
// the page, so only the non-PHI fields the dialog reads are selected.
export const mergeFillLaterItemGql = gql`
  mutation mergeFillLaterItem($input: MergeFillLaterItemInput!) {
    mergeFillLaterItem(input: $input) {
      fillLaterItemId
      status
      mergeable
    }
  }
`;

export const cancelFillLaterItemGql = gql`
  mutation cancelFillLaterItem($input: CancelFillLaterItemInput!) {
    cancelFillLaterItem(input: $input) {
      fillLaterItemId
      status
    }
  }
`;

export const updateFillLaterAddressGql = gql`
  mutation updateFillLaterAddress($input: UpdateFillLaterAddressInput!) {
    updateFillLaterAddress(input: $input) {
      fillLaterItemId
      status
      addressDirectoryId
    }
  }
`;

export const moveLineItemsToFillLaterGql = gql`
  mutation moveLineItemsToFillLater($input: MoveLineItemsToFillLaterInput!) {
    moveLineItemsToFillLater(input: $input)
  }
`;

export const createFillLaterItemNowGql = gql`
  mutation createFillLaterItemNow($fillLaterItemId: String!) {
    createFillLaterItemNow(fillLaterItemId: $fillLaterItemId) {
      outcome
      fillLaterItemId
      splitOrderId
      splitItemId
      reason
    }
  }
`;
